// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductClickForSearchPageParameters } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLinkProps";
import { useRecordBrandNameClickEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordBrandNameClickEvent";
import { useRecordChooseOptionClickEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordChooseOptionClickEvent";
import { useRecordChooseOptionQuantityUpdateSubmitEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordChooseOptionQuantityUpdateSubmitEvent";
import { useRecordHeartClickEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordHeartClickEvent";
import { useRecordProductBadgeViewEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordProductBadgeViewEvent";
import { useRecordProductTileClickEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordProductTileClickEvent";
import { useRecordProductTileMiddleClickEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordProductTileMiddleClickEvent";
import { useRecordProductTileRightClickEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordProductTileRightClickEvent";
import { useRecordQuickAddButtonClickEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordQuickAddButtonClickEvent";
import { useRecordQuickAddSubmitEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordQuickAddSubmitEvent";
import { useRecordRemoveFromBoardSubmitEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordRemoveFromBoardSubmitEvent";
import { useRecordSaveToBoardSubmitEvent } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/__internal__/events/useRecordSaveToBoardSubmitEvent";

import { useRecordSwatchImageClickEvent } from "./__internal__/events/useRecordSwatchImageClickEvent";
import { useRecordSwatchImageHoverEvent } from "./__internal__/events/useRecordSwatchImageHoverEvent";

export const useProductTileClickImpressions = (
  params: ProductClickForSearchPageParameters = {},
  brandToken?: string
) => {
  /**
   * All tracking events added here MUST be no-op
   */
  const recordProductTileClickEvent = useRecordProductTileClickEvent(
    params.token,
    params.isPromoted,
    params.impressionId,
    params.promotedBy
  );
  const recordProductTileMiddleClickEvent =
    useRecordProductTileMiddleClickEvent(
      params.token,
      params.impressionId,
      params.promotedBy
    );
  const recordBrandNameClickEvent = useRecordBrandNameClickEvent(
    params.token,
    params.isPromoted,
    params.impressionId,
    params.promotedBy,
    brandToken
  );
  const recordProductTileRightClickEvent = useRecordProductTileRightClickEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );
  const recordProductBadgeViewEvent = useRecordProductBadgeViewEvent(
    params.token,
    params.badgeList
  );

  // Board Events
  const recordHeartClickedEvent = useRecordHeartClickEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );
  const recordSaveToBoardSubmitEvent = useRecordSaveToBoardSubmitEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );
  const recordRemoveFromBoardSubmitEvent = useRecordRemoveFromBoardSubmitEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );

  // QuickAdd Events
  const recordQuickAddButtonClickEvent = useRecordQuickAddButtonClickEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );
  const recordQuickAddSubmitEvent = useRecordQuickAddSubmitEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );
  const recordChooseOptionClickEvent = useRecordChooseOptionClickEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );
  const recordChooseOptionQuantityUpdateSubmitEvent =
    useRecordChooseOptionQuantityUpdateSubmitEvent(
      params.token,
      params.impressionId,
      params.promotedBy
    );

  const recordSwatchImageClickEvent = useRecordSwatchImageClickEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );
  const recordSwatchImageHoverEvent = useRecordSwatchImageHoverEvent(
    params.token,
    params.impressionId,
    params.promotedBy
  );

  return {
    recordProductTileClickEvent,
    recordProductTileMiddleClickEvent,
    recordBrandNameClickEvent,
    recordProductTileRightClickEvent,
    recordProductBadgeViewEvent,
    recordHeartClickedEvent,
    recordSaveToBoardSubmitEvent,
    recordRemoveFromBoardSubmitEvent,
    recordQuickAddButtonClickEvent,
    recordQuickAddSubmitEvent,
    recordChooseOptionClickEvent,
    recordChooseOptionQuantityUpdateSubmitEvent,
    recordSwatchImageClickEvent,
    recordSwatchImageHoverEvent,
  };
};
